export enum NoteSeverity {
    SystemLog = 0,
    InstallerInput = 10,
    OperatorInput = 20,
    AdminInput = 30,
}